import { Entity } from '@data-client/rest';
import { ISODate } from '../utils/transforms';
class EncryptionAccessLogEntity extends Entity {
    constructor() {
        super(...arguments);
        this.countryName = null;
        this.creationDTTM = new Date(0);
        this.deviceName = null;
        this.deviceTypeId = null;
        this.email = null;
        this.encryptionAccessLogId = 0;
        this.encryptionId = 0;
        this.eventType = null;
        this.latitude = null;
        this.longitude = null;
        this.platform = null;
        this.status = null;
        this.statusDetails = null;
        this.userDeviceId = null;
        this.userId = null;
    }
    pk() {
        return this.encryptionAccessLogId.toString();
    }
}
EncryptionAccessLogEntity.schema = {
    creationDTTM: ISODate
};
EncryptionAccessLogEntity.key = 'EncryptionAccessLog';
export { EncryptionAccessLogEntity };
